import { ThemeUICSSObject } from '@apia/theme';
import selector from './selector';
import editor from './editor';
/* IMPORT HERE */
const styles: ThemeUICSSObject = {
  editor,
  selector,
  /* PREPEND HERE */
};

export default styles;
